import { FETCH_TOP_STUDENT_SCORES } from '../constants/student-score';

export function fetchTopStudentScores(rankType, number) {
  return {
    type: FETCH_TOP_STUDENT_SCORES,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: `/students/student-scores/${rankType}/${number}`
    }
  };
}
